import Employer from '@/model/Employer'

export default class User {
    static PRIVILEGES = {
        'chemg': 1,
        'wrmg': 2,
        'manage-employers': 32,
        'manage-users': 64,
        'admin': 128
    }

    static parsePrivileges (v) {
        var self = this
        var res = {}
        Object.keys(self.PRIVILEGES).forEach(priv => {
            res[priv] = parseInt(v & self.PRIVILEGES[priv]) > 0
        })
        return res
    }

    static compilePrivileges (parr) {
        var self = this
        var res = 0
        Object.keys(self.PRIVILEGES).forEach(priv => {
            if (parr[priv]) {
                res |= self.PRIVILEGES[priv]
            }
        })
        return res
    }

    static fromObject (data) {
        var u = new User()

        if (typeof data !== 'object') {
            throw new Error('cannot load user data from non-object')
        }

        var problems = []
        if (typeof data.uuid !== 'string') {
            problems.push('uuid')
        } else {
            u.uuid = data.uuid
        }

        if (typeof data.email !== 'string') {
            problems.push('email')
        } else {
            u.email = data.email
        }

        if (typeof data.otpActive !== 'boolean') {
            problems.push('otpActive')
        } else {
            u.otpActive = data.otpActive
        }

        if (typeof data.created !== 'string') {
            problems.push('created')
        } else {
            u.created = data.created
        }

        if (typeof data.privileges !== 'number') {
            problems.push('privileges')
        } else {
            u.privileges = data.privileges
            u.parsedPrivileges = User.parsePrivileges(u.privileges)
        }

        if (typeof data.name !== 'string') {
            problems.push('name')
        } else {
            u.name = data.name
        }
        
        if (typeof data.username !== 'string') {
            problems.push('username')
        } else {
            u.username = data.username
        }

        if (typeof data.employerUuid !== 'string') {
            problems.push('employerUuid')
        } else {
            u.employerUuid = data.employerUuid
        }

        if (problems.length > 0) {
            throw new Error(`missing user data or found invalid values for: ${JSON.stringify(problems)}`)
        }

        // add optional fields
        if (typeof data.verified === 'string') {
            u.verified = data.verified
        }
        if (typeof data.locked === 'string') {
            u.locked = data.locked
        }
        if (typeof data.modified === 'string') {
            u.modified = data.modified
        }
        if (typeof data.lastLogin === 'string') {
            u.lastLogin = data.lastLogin
        }
        if (typeof data.phone === 'string') {
            u.phone = data.phone
        }
        if (typeof data.password === 'string') {
            u.password = data.password
        }
        if (typeof data.hasPassword === 'boolean') {
            u.hasPassword = data.hasPassword
        }
        u.acceptedToS = typeof data.acceptedToS === 'string' ? data.acceptedToS : ''
        if (typeof data.state === 'string') {
            u.state = data.state
        }

        if (typeof data.employer === 'object') {
            try {
                u.employer = Employer.fromObject(data.employer)
            } catch (_) {
                // ignore, field is optionl
            }
        }

        return u
    }

    static passwordMeetsRequirements (password) {
        if (typeof password !== 'string' ||
                password.length < 10) {
            return false
        }

        var hasUpcaseLetter = false
        var hasDowncaseLetter = false
        var hasNumber = false
        var hasSpecialCharacter = false
        for (var i = 0; i < password.length; ++i) {
            var c = password.charCodeAt(i)

            if (c > 64 && c < 91) {
                hasUpcaseLetter = true
            } else if (c > 96 && c < 123) {
                hasDowncaseLetter = true
            } else if (c > 47 && c < 58) {
                hasNumber = true
            } else {
                hasSpecialCharacter = true
            }

            if (hasUpcaseLetter && hasDowncaseLetter && hasNumber && hasSpecialCharacter) {
                return true
            }
        }

        return false
    }

    constructor () {
        this.uuid = ''
        this.email = ''
        this.otpActive = false
        this.created = ''
        this.locked = ''
        this.modified = ''
        this.lastLogin = ''
        this.privileges = 0
        this.name = ''
        this.password = null
        this.hasPassword = false
        this.username = ''
        this.employerUuid = ''
        this.phone = ''
        this.verified = null
        this.acceptedToS = ''
        this.state = ''

        this.parsedPrivileges = {}
        this.employer = {}
        this.hasPassword = false
    }

    hasPrivilege (key) {
        return typeof this.parsedPrivileges[key] !== 'undefined' && this.parsedPrivileges[key]
    }

    mayGivePrivilege (key) {
        if (this.hasPrivilege('admin')) {
            return true
        }
        if (User.PRIVILEGES[key] >= 32 && this.employer.identifier !== 'BfR') {
            return false
        }
        return this.hasPrivilege('manage-users') && this.hasPrivilege(key)
    }
}
